// noinspection EqualityComparisonWithCoercionJS
import {Component, h} from 'preact';
import {compareTwoStrings} from "../utils/strings-similarity";

export default class DatalistInput extends Component {
    componentWillMount() {
        this.state = {
            inputvalue: !!this.props.initialvalue? this.props.initialvalue : '',
            showsuggest: false,
            showloading: false,
            waitTimeout: null,
            isfinalvalue: false,
            lastsearch: {
                searchstring: '',
                searchresults: []
            }
        };

        this.applyFilter(this.props.list);

        window.document.addEventListener('mousedown', this.mouseDownListener = e => {
            if (!e.composedPath().includes(this.root)) {
                setTimeout(() => {
                    if (!this.state.isfinalvalue) {
                        const inputvalue = !!this.state.lastsearch.searchresults.length ?
                            this.state.lastsearch.searchresults[0].value
                            : this.state.inputvalue;

                        if (!!this.props.onInput) {
                            this.props.onInput({target: {value: inputvalue}}, this.state.lastsearch.searchresults[0]);
                        }

                        this.state.inputvalue = inputvalue;
                        this.state.isfinalvalue = true;
                    }

                    this.state.showsuggest = false;
                    this.setState(this.state);
                }, 150);
            }
        });
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (!!nextProps.initialvalue) {
            this.state.inputvalue = nextProps.initialvalue;
            this.setState(this.state);
        }
    }

    inputCallback(e, usefilter = true, item = null) {
        this.state.showsuggest = false;
        this.state.isfinalvalue = !usefilter;
        this.state.inputvalue = e.target.value;

        if (this.state.waitTimeout !== null) {
            clearTimeout(this.state.waitTimeout);
            this.state.waitTimeout = null;
        }

        this.state.waitTimeout = setTimeout(
            () => {
                if (usefilter) {
                    this.setState({showloading: true, showsuggest: true});
                    setTimeout(() => this.applyFilter(this.props.list), 150);
                }

                if (!!this.props.onInput) {
                    this.props.onInput(e, item);
                }
            },
            600
        );
    }

    applyFilter(list) {
        if (this.state.inputvalue === '') {
            this.state.lastsearch.searchstring = this.state.inputvalue;
            this.state.lastsearch.searchresults = list.slice(0,50).map(
                item => {
                    if (!!item.value) {
                        if (!item.label) {
                            item.label = item.value;
                        }
                        item.matchpercentage = 0;
                        return item;
                    } else {
                        return {
                            label: item,
                            value: item,
                            matchpercentage: 0
                        };
                    }
                }
            );
        }

        if (this.state.inputvalue !== this.state.lastsearch.searchstring) {
            const terms = this.state.inputvalue.split(' ');

            //> Cerco di velocizzare disperatamente la ricerca cercando almeno una porzione del testo nel mercato
            let results = [];
            list = list.filter(
                item => {
                    if (!!item.value) {
                        const label = !!item.label ? item.label : item.value;

                        for (let i = 0; i < terms.length; ++i) {
                            if (label.toLowerCase().indexOf(terms[i].toLowerCase()) !== -1) {
                                return true;
                            }
                        }
                    } else {
                        for (let i = 0; i < terms.length; ++i) {
                            if (item.toLowerCase().indexOf(terms[i].toLowerCase()) !== -1) {
                                return true;
                            }
                        }
                    }
                }
            );

            for (let i = 0; i < list.length; ++i) {
                const item = list[i];
                let rating = {};

                if (!!item.value) {
                    if (!item.label) {
                        item.label = item.value;
                    }
                    item.matchpercentage = this.state.inputvalue == item.value || this.state.inputvalue == (!!item.label ? item.label : item.value) ?
                        100
                        // : parseInt(similarity(!!item.label? item.label : item.value, this.state.inputvalue)*10000)/100
                        : parseInt(compareTwoStrings(!!item.label ? item.label : item.value, this.state.inputvalue) * 100);

                    rating = item;
                } else {
                    // noinspection EqualityComparisonWithCoercionJS
                    rating = {
                        label: item,
                        value: item,
                        matchpercentage: this.state.inputvalue == item ?
                            100
                            // : parseInt(similarity(item, this.state.inputvalue)*10000)/100
                            : parseInt(compareTwoStrings(item, this.state.inputvalue) * 100)
                    };
                }

                if (rating.matchpercentage === 100) {
                    results = [rating];
                    break;
                }

                results.push(rating);
            }

            this.state.lastsearch.searchstring = this.state.inputvalue;
            this.state.lastsearch.searchresults = results
                .sort((a,b) => b.matchpercentage - a.matchpercentage)
                .slice(0,50);
        }

        this.state.showloading = false;
        this.setState(this.state);
    }

    render({
        list = [],
        containerclass = null,
        inputclass = null,
        inputid = null,
        suggestclass = null,
        itemclass = null,
        onInput = null,
        placeholder = null
    }) {
        return <div ref={r => this.root = r} class={"inline-block relative" + (!!containerclass? ' ' + containerclass : '')}>
            <input
                id={inputid}
                type="text"
                autocomplete="off"
                value={this.state.inputvalue}
                onInput={e => this.inputCallback(e)}
                class={(!!inputclass? inputclass : '')}
                onFocus={e => this.setState({showsuggest: true})}
                placeholder={placeholder}
            />
            {!!this.state.showsuggest && !!this.state.lastsearch.searchresults.length && <div class={(!!suggestclass? suggestclass + ' ' : 'w-full left-0 border border-gray-300 rounded-b z-30 bg-white shadow-md') + " fixed"}>
                {!!this.state.showloading && <div class="fixed z-40 top-0 left-0 right-0 bottom-0 opacity-50 bg-black text-white text-center">
                    <i class="fa fa-cog fa-spin absolute" style="top:47%;left:46%" />
                </div>}
                {!!this.state.lastsearch.searchresults && <div class="overflow-auto" style="max-height:200px; min-height:30px">
                    {this.state.lastsearch.searchresults.map(
                    item => <a
                        href="javascript:void(0);"
                        class={(!!itemclass? itemclass + ' ' : 'p-2 text-xs truncate hover:bg-blue-200 ') + "block"}
                        onClick={e => this.inputCallback({target:{value:item.value}}, false, item)}
                    >
                        {item.label}
                    </a>)}
                </div>}
            </div>}
        </div>;
    }
}